<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>{{$route.params.type}} Docs</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text v-if="$route.params.type=='Export'">
            <div class="row mt-3">
              <div class="col-md-2">
                <label>BOOKING ORDER</label>
                <div v-if="ffBookingOrder.length>0">
                  <div class="row" v-for="(item,index) in ffBookingOrder" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item.uploadBooking!='' && item.uploadBooking!=null"
                        :href="`${docURL}/FF_Sea_Export_Uploads/`+item.uploadBooking"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>
              <div class="col-md-2">
                <label>SHIPPER INVOICE</label>
                <div v-if="SBPageDocs.length>0">
                  <div class="row" v-for="(item1,index) in SBPageDocs" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item1.invoiceUpload!='' && item1.invoiceUpload!=null"
                        :href="`${docURL}/FF_Sea_Export_Uploads/`+item1.invoiceUpload"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>
              <div class="col-md-2">
                <label>CARGO LIST</label>
                <div v-if="SBPageDocs.length>0">
                  <div class="row" v-for="(item10,index) in SBPageDocs" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item10.cargoUpload!='' && item10.cargoUpload!=null"
                        :href="`${docURL}/FF_Sea_Export_Uploads/`+item10.cargoUpload"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>

              <div class="col-md-2">
                <label>LET EXPORT COPY</label>
                <div v-if="LETEXPORTMAILDOC.length>0">
                  <div class="row" v-for="(item101,index) in LETEXPORTMAILDOC" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item101.upload_doc_mail!='' && item101.upload_doc_mail!=null"
                        :href="`${docURL}/FF_EX_LET_MAILDOC_CLOUDMAILING_UPLOADS/`+ item101.upload_doc_mail"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>

              <div class="col-md-3">
                <label>SHIPPING BILL</label>
                <div v-if="SBPageDocs.length>0">
                  <div class="row" v-for="(item3,index) in SBPageDocs" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item3.shippingBillUpload!='' && item3.shippingBillUpload!=null"
                        :href="`${docURL}/FF_Sea_Export_Uploads/`+item3.shippingBillUpload"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>
            </div>

            <!-- <div class="row mt-3" v-if="SBPageDocs.length>0">
              <div class="col-md-2" v-for="(item4,index) in SBPageDocs" :key="index">
                <label style=" text-transform: uppercase !important;">{{item4.trackingDoc}}</label>
                <div class="col-md-12">
                  <a
                    style="margin-left:-15px"
                    :href="`${docURL}/CC_Import_Uploads/`+item4.cargoUpload"
                    target="_blank"
                    download
                  >View Document</a>
                </div>
              </div>
            </div>-->
          </b-card-text>
          <b-card-text v-if="$route.params.type=='AirExport'">
            <div class="row mt-3" v-if="airExportExecPageDoc.length>0">
              <div class="col-md-2" v-for="(item4,index) in airExportExecPageDoc" :key="index">
                <label style=" text-transform: uppercase !important;">{{item4.documentType}}</label>
                <div class="col-md-12">
                  <a
                    style="margin-left:-15px"
                    :href="`${docURL}/FF_Air_Export_Uploads/`+item4.uploadDocumentType"
                    target="_blank"
                    download
                  >View Document</a>
                </div>
              </div>
            </div>
          </b-card-text>
          <b-card-text v-if="$route.params.type=='Import'">
            <div class="row mt-3">
                 <div class="col-md-2">
                <label>Shipment Arrival Notice</label>
                <div v-if="SeaImportEntryPageDoc.length>0">
                  <div class="row" v-for="(item5,index) in SeaImportEntryPageDoc" :key="index">
                    <div class="col-md-12">
                      <a
                      class="showMoreData"
                        v-if="item5.shippingArrivalNoticmailSentDate!=null"
                        @click="SendShipmentArrival(item5.ffImportId)"
                        target="_blank"
                        download
                      >View Document - {{index+1}}<br>
                      Sent on {{item5.shippingArrivalNoticmailSentDate}}
                      </a>
                      <span v-else class="error">Shipment Arrival Notice Not Sent</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Shipment Arrival Notice Not Sent</span>
                </div>
              </div>
              <div class="col-md-2">
                <label>BL 1</label>
                <div v-if="SeaImportEntryPageDoc.length>0">
                  <div class="row" v-for="(item,index) in SeaImportEntryPageDoc" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item.firstBLupload!='' && item.firstBLupload!=null"
                        :href="`${docURL}/FF_Sea_Import_Uploads/`+item.firstBLupload"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>
              <div class="col-md-2">
                <label>HOUSE BL</label>
                <div v-if="SecBLSeaImportEntryPageDoc.length>0">
                  <div class="row" v-for="(item1,index) in SecBLSeaImportEntryPageDoc" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item1.secondBLupload!='' && item1.secondBLupload!=null"
                        :href="`${docURL}/FF_Sea_Import_Uploads/`+item1.secondBLupload"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>
              <div class="col-md-2">
                <label>DO</label>
                <div v-if="execSeaImportEntryPageDoc.length>0">
                  <div class="row" v-for="(item10,index) in execSeaImportEntryPageDoc" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item10.uploadDO!='' && item10.uploadDO!=null"
                        :href="`${docURL}/FF_Sea_Import_Uploads/`+item10.uploadDO"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>

              <div class="col-md-3">
                <label>OTHER DOCUMENTS</label>
                <div v-if="execSeaImportEntryPageDoc.length>0 && execSeaImportEntryPageDoc[0].uploadDoC!='' && execSeaImportEntryPageDoc[0].uploadDoC!=null">
                 
                  <div class="row" v-for="(item3,index) in execSeaImportEntryPageDoc[0].uploadDoC.split(',')" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item3!='' && item3!=null"
                        :href="`${docURL}/FF_Sea_Import_Uploads/`+item3"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>
            </div>
            <div>
              

<hr v-if="emailData!=''">
<div v-html="emailData"></div>
              
              
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="alertAddSeaImp"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (
      (globalPermissionStatus("Sea Freight") ||
        globalPermissionStatus("Air Freight")) &&
      this.$route.params.ffExportFclId != undefined &&
      this.$route.params.ffExportFclId != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCImportEntry");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  watch: {},
  data() {
    return {
       validate: true,
      isLoading: true,
      docURL: URL_BASE_DOC,

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      emailData: "",
      shipperVgmDoc: "",
      shippingBillDoc: "",
      deliveryOrderDoc: "",
      approvedCheckListDoc: "",
      SBPageDocs: [],
      LETEXPORTMAILDOC: [],
      ffBookingOrder: [],
      SeaImportEntryPageDoc: [],
      SecBLSeaImportEntryPageDoc: [],
      execSeaImportEntryPageDoc: [],
      airExportExecPageDoc: []
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor
  },
  computed: {
    vgmUploadView() {
      return this.shipperVgmDoc != "" && this.shipperVgmDoc != null
        ? this.shipperVgmDoc.split(",")
        : [];
    },
    sbUploadView() {
      return this.shippingBillDoc != "" && this.shippingBillDoc != null
        ? this.shippingBillDoc.split(",")
        : [];
    },
    doUploadView() {
      return this.deliveryOrderDoc != "" && this.deliveryOrderDoc != null
        ? this.deliveryOrderDoc.split(",")
        : [];
    },

    approveCheckUploadView() {
      return this.approvedCheckListDoc != "" &&
        this.approvedCheckListDoc != null
        ? this.approvedCheckListDoc.split(",")
        : [];
    }
  },

  methods: {
     SendShipmentArrival(ID){
      let payLoad={
        mailAlert:"mailAlert",
        sendMail:"No",
        ffImportId:ID
      
      }
       

      if (this.validate == true) {
      
        let options = {
          method: "POST",
          url: `${URL_BASE}/sendShipmentArrivalNotice.php`,
          data: JSON.stringify(payLoad),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
             this.emailData=data.emailData
             
         
            }
          })
          .catch(error => {});
      }

    },
    previousFFView() {
      window.history.go(-1);
    },
    getData() {
      this.isLoading = true;

      let vehicle_drive = {
        itemCode: "itemCode",
        ffExportFclId: this.$route.params.ffExportFclId,
        type: this.$route.params.type
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/getDataFFSeaDocs.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            // if (data.ediExecutionPageDoc.length > 0) {
            //   this.shipperVgmDoc = data.ediExecutionPageDoc[0].vgmUpload;
            //   this.shippingBillDoc = data.ediExecutionPageDoc[0].uploadBoe;
            //   this.approvedCheckListDoc =
            //     data.ediExecutionPageDoc[0].checklistUpload;
            // }
            if (data.SBPageDocs.length > 0) {
              this.SBPageDocs = data.SBPageDocs;
            } else {
              this.SBPageDocs = [];
            }

            if (data.LETEXPORTMAILDOC.length > 0) {
              this.LETEXPORTMAILDOC = data.LETEXPORTMAILDOC;
            } else {
              this.LETEXPORTMAILDOC = [];
            }

            if (data.ffBookingOrder.length > 0) {
              this.ffBookingOrder = data.ffBookingOrder;
            }
            if (data.SeaImportEntryPageDoc.length > 0) {
              this.SeaImportEntryPageDoc = data.SeaImportEntryPageDoc;
            }
            if (data.SecBLSeaImportEntryPageDoc.length > 0) {
              this.SecBLSeaImportEntryPageDoc = data.SecBLSeaImportEntryPageDoc;
            }
            if (data.execSeaImportEntryPageDoc.length > 0) {
              this.execSeaImportEntryPageDoc = data.execSeaImportEntryPageDoc;
            }
            if (data.airExportExecPageDoc.length > 0) {
              this.airExportExecPageDoc = data.airExportExecPageDoc;
            }

            this.isLoading = false;
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style scoped>
 table{ border-collapse: collapse; width:100% } th, td { border: 1px solid black; padding:5px }
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ffDocListPage.vue?66751298